<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <!--醫院簡介 科別簡介-->
    <v-flex xs12>
        <v-card class="cardBgColorStyle">

            <v-card row wrap dark  color="secondary"  dense style="padding:0px 0px">

                <v-flex  d-inline-flex style="margin-bottom: -5px">
                    <v-btn @click="addItem"  dark fab top right color="accent" class="mb-2 mt-0">
                        <v-icon >mdi-plus</v-icon>
                    </v-btn>
                </v-flex>

                <!--程式名稱-->
                <v-flex d-inline-flex pl-2 style="font-size: 1.2rem;margin-bottom: -5px">
                    {{this.menuInfo.funTitle}}
                </v-flex>

                <v-flex xs12 sm6 md3 d-inline-flex>
                    <v-flex xs5 sm5 md4 text-right  class="labelFont">
                        <span style="color: white!important;">簡介類別</span>
                    </v-flex>
                    <v-flex xs7 sm7 md8 pl-2>
                        <v-autocomplete
                                class="mr-2"
                                v-model="docType"
                                hide-details
                                :items="docList"
                                item-text="value"
                                item-value="key"
                        ></v-autocomplete>
                    </v-flex>
                </v-flex>

                <v-flex xs12 sm6 md2 d-inline-flex>
                    <v-flex xs5 sm5 md5 text-right  class="labelFont">
                        <span style="color: white!important;">科別代號</span>
                    </v-flex>
                    <v-flex xs7 sm7 md7 pl-2>
                        <v-text-field   v-model="docCode"   clearable ></v-text-field>
                    </v-flex>
                </v-flex>

                <v-flex xs12 sm6 md3 d-inline-flex>
                    <v-flex xs5 sm5 md5 text-right  class="labelFont">
                        <span style="color: white!important;">院區代號</span>
                    </v-flex>
                    <v-flex xs7 sm7 md7 pl-2 >
                        <v-select
                                v-if="zoneNameList.length>0"
                                dark
                                v-model="zoneType"
                                hide-details
                                :items="zoneNameList"
                                :item-text="zoneItemText"
                                item-value="zone"
                        ></v-select>

                        <v-text-field v-else  v-model="zoneType"   clearable ></v-text-field>

                    </v-flex>
                </v-flex>

                <v-btn   dark  top right class="mt-2 mx-2 regFRBtn"    @click="axios_getHospDocListData (zoneType,docType,docCode)">
                    <v-icon>mdi-magnify</v-icon>查詢
                </v-btn>

                <v-btn class="mt-2 regFRBtn"   @click="axios_getHospDocListData (zoneType,'ALL','ALL')"> <v-icon>mdi-magnify</v-icon>查詢全部</v-btn>

                <v-flex row wrap dark  style="margin-bottom: -10px">



                </v-flex>







            </v-card>



            <v-flex style="padding-top:1rem">
                <v-data-table
                        dense
                        :search="search"
                        id="funListTable"
                        :loading="funListLoading"
                        :headers="funListHeaders"
                        :items="doctorDataFilter"
                        @page-count="pagination.pageCount = $event"
                        :page.sync="pagination.page"
                        :sort-by="pagination.sortBy"
                        :sort-desc="pagination.descending"
                        :loading-text="loadingText"
                        :items-per-page="pagination.rowsPerPage"
                        hide-default-footer
                        hide-default-header
                        item-key="chart_no"
                        v-resize="resizeFunListGrid"
                        class="elevation-1">

                    <template v-slot:header="{ props }">
                        <tr class="px-1 text-left tablehead">
                            <th v-for="header in props.headers"
                                :key="header.text"
                                :class="['column sortable',pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '','px-1']"
                                @click="changeSort(header.value)">
                                <span  v-html="header.text"></span>
                                <v-icon small
                                        :style="{display:header.value === pagination.sortBy ? pagination.descending ? 'none' : 'inline' : 'none'}">
                                    mdi-arrow-up
                                </v-icon>
                                <v-icon small
                                        :style="{display:header.value === pagination.sortBy ? pagination.descending ? 'inline' : 'none' : 'none'}">
                                    mdi-arrow-down
                                </v-icon>
                            </th>
                        </tr>
                    </template>

                    <template slot="item" slot-scope="props" style="border: 1px solid black">

                        <tr>
                            <td class=" align-space-around justify-space-around fill-height px-0" >
                                <v-layout>
                                    <v-btn icon class="mx-0" @click.native.stop="editItem(props.item)"> <!---->
                                        <v-icon color="tertiary">mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn icon class="mx-0" @click.native.stop="deleteItem(props.item)"><!---->
                                        <v-icon color="tertiary">mdi-delete</v-icon>
                                    </v-btn>
                                </v-layout>

                            </td>
                            <td  class="px-1 text-left" style="min-width: 80px">{{ props.item.docType}} </td>
                            <td  class="px-1 text-left" style="min-width: 100px">{{ props.item.docCode}}</td>
                            <td  class="px-1 text-left" style="min-width: 50px">{{ props.item.zone}}</td>
                            <td  class="px-1 text-left" style="min-width: 50px">
                                <img :src="props.item.docImage" width="150px">
                            </td>
                            <td  class="px-1 text-left" style="white-space: pre-line" v-html="props.item.hospDoc"></td>



                        </tr>
                    </template>
                    <template slot="pageText" slot-scope="props">
                        第 {{ props.pageStart }} - {{ props.pageStop }} ,共 {{ props.itemsLength }} 筆
                    </template>
                    <template slot="no-data">

                        <v-alert :value='countDownNo>=5' type="warning" icon="mdi-alert-circle">
                            查詢中...
                        </v-alert>
                        <v-alert :value='tableAlert' color="info" icon="mdi-information">
                            表格中沒有內容
                        </v-alert>

                    </template>
                    <!--<v-alert slot="no-results" :value="true" color="info" icon="mdi-alert-circle">-->
                    <!--Your search for " {{ search }} " found no results.-->
                    <!--</v-alert>-->
                </v-data-table>
                <v-layout row wrap>
                    <v-flex xs12 md2>
                        <v-text-field
                                v-model="search"
                                class="ml-2 mt-2"
                                prepend-inner-icon="mdi-magnify"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-flex>


                    <v-flex xs12 md6 text-center pt-2>
                        <v-pagination color="accent" v-model="pagination.page" :length="pagination.pageCount" :total-visible="7"></v-pagination>
                    </v-flex>
                    <v-flex xs6 md2 pt-2 pr-2 pl-2>
                        <v-select
                                :items="pageItem"
                                label="每頁筆數"
                                item-value="value"
                                v-model="pagination.rowsPerPage"
                        ></v-select>
                    </v-flex>
                    <v-flex xs6 md2 text-left pt-2 pr-2>
                        <v-text-field
                                label="總筆數"
                                v-model="doctorDataFilter.length"
                                readonly
                        ></v-text-field>
                    </v-flex>
                </v-layout>

            </v-flex>



        </v-card>

        <v-dialog v-model="editDialog"
                  eager
                  xs6 sm6 md6
                  :width="editDialogWidth+'%'"
                  value="false"
                  scrollable>
            <edit-hsop-doc :zone-name-list="zoneNameList"   :is-show="editDialog" @closeDialog="closeDialog" @save="save" :edit-index="editIndex" :edit-obj="editObj"></edit-hsop-doc>
        </v-dialog>

        <v-dialog v-model="deleteDialog"
                  width="50%"
                  xs6 sm6 md6
                  value="false"
                  scrollable>
            <delete-info-dialog @closeDelete="closeDelete" @confirmDelete="confirmDelete" :delete-title="deleteTitle" :delete-content="deleteContent"></delete-info-dialog>
        </v-dialog>

        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>


    </v-flex>
    
</template>

<script>
    import EditHsopDoc from './EditHsopDoc'
    import DeleteInfoDialog from '../inursingsys/DeleteInfoDialog'
    export default {
        name: "HospDocMaintain",
        components:{DeleteInfoDialog,EditHsopDoc},
        data() {
            return {
                zoneNameList:[],
                //程式功能清單
                countDownId: null, //data 定義一個定時器id
                countDownNo:0,
                tableAlert:false,
                effFlag:true,
                funListLoading:false,
                loadingText:'查詢中...',
                search:'',
                snTimeout:4000,
                snStatus:false,
                snText:'',
                deleteDialog:false,
                deleteTitle:'刪除 醫院/科別簡介',
                deleteContent:'',
                deleteObj:{},
                editDialog:false,
                editIndex:-1,
                editObj:{},
                doctorList: [],
                systemId:'',
                pagination: {
                    sortBy: 'dataType',
                    rowsPerPage:100,
                    page: 1,
                    pageCount: 0,
                    descending:false
                },
                pageItem:[
                    {text:100,value:100},
                    {text:20,value:20},
                    {text:"All",value:-1},
                ],
                pageText:'每頁筆數 :',
                funListHeaders:[
                    {
                        text: '',
                        align: 'center',
                        // value: 'assessDate'
                    },
                    {
                        text: '簡介類別',
                        // align: 'left',
                        value: 'docType',
                        class:'px-1'
                    },
                    {
                        text: '科別/院區代號',
                        // align: 'center',
                        value: 'docCode',
                        class:'px-1'
                    },
                    {
                        text: '院區代號',
                        // align: 'center',
                        value: 'zone',
                        class:'px-1'
                    },
                    {
                        text: '圖形內容',
                        // align: 'center',
                        value: 'docImage',
                        class:'px-1'
                    },
                    {
                        text: '醫院說明',
                        // align: 'center',
                        value: 'hospDoc',
                        class:'px-1'
                    },

                ],
                docType:'',
                docCode:'',
                zoneType:'A',
                docList:[
                    {key:'HOSP',value:'HOSP-醫院'},
                    {key:'DIV',value:'DIV-科別'},
                    {key:'SELFDIV',value:'SELFDIV-自定義科別'},
                ],

            }
        },
        created(){
            this.axios_getZoneNameALL();
        },
        computed:{
            menuInfo() {
                return this.$store.state.menuInfo;
            },

            editDialogWidth(){ //隨畫面大小 調整Dialog的寬度
                let width = 50;
                if (this.$vuetify.breakpoint.xs == true) {width = 100 }
                if(this.$vuetify.breakpoint.sm == true){width = 97}
                if(this.$vuetify.breakpoint.md == true){width =  60}
                if(this.$vuetify.breakpoint.lg == true){width =  50}
                if(this.$vuetify.breakpoint.xl ==true){width =  50}
                return width
            },

            doctorDataFilter(){
                return this.doctorList.filter((item) => {
                    if(this.divNo!==""){
                        return (item.divNo==this.divNo);
                    }else {
                        return this.doctorList;
                    }

                });
            },
        },
        watch:{
        },
        methods:{
            zoneItemText: item => item.zone==''?'':item.zone + '-' + item.zoneName, //格式化 院區顯示文字
            divItemText: item => item.divNo==''?'':item.divNo + '-' + item.divName, //格式化 autocomplete 選權限顯示文字
            countDown(){
                if(this.countDownId != null ) return;
                this.countDownId = setInterval(() => {
                    this.countDownNo++
                },1000)
            },
            //停止計時器
            stopCountDown(){
                clearInterval(this.countDownId);
                //當我清除定時器之後，重新讓countDownId為null , countDownNo歸零
                this.countDownId = null;
                this.countDownNo=0;
            },
            changeSort: function(column) {
                // console.log(column);
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column;
                    this.pagination.descending = false
                }
            },
            closeDelete(){
                this.deleteDialog = false;

            },
            confirmDelete(){
                this.axios_deleteDoctor(this.deleteObj);
            },
            transformUTC(utc,flag){ //uct->Date ; flag-> all,date,time
                let date =  this.$UtilityJs.AD2ROC_DateTime(utc,flag);
                return (date)
            },
            addItem(){  //新增按鈕
                this.editDialog = true;
                this.editIndex = -1;
            },
            closeDialog(){ //關閉編輯視窗
                this.editDialog = false;
            },
            editItem:function(item){
                this.editIndex = this.doctorDataFilter.indexOf(item);
                this.editObj = item;
                this.editDialog = true;
            },
            deleteItem:function(item){  //刪除
                this.deleteObj = item;
                this.deleteDialog = true;
                this.deleteContent = '確定要刪除，[簡介類別 '+item.docType+" / 科別代號/醫院代號 "+item.docCode+" / 院區代號 "+item.zone+"]記錄";
            },
            save(item){
                if(this.editIndex==-1){ //新增
                    this.axios_postHospDoc(item);
                }else { //修改
                    this.axios_putHospDoc(item);
                }
            },
            resizeFunListGrid:function(){
                var userHeight = window.innerHeight
                    || document.documentElement.clientHeight
                    || document.body.clientHeight;
                let height = userHeight-(270);
                let funListTable = document.getElementById('funListTable');
                funListTable.setAttribute('style','overflow-y: auto;min-height:'+height+'px;max-height:'+height+'px;');
            },
            axios_getHospDocListData (zone,docType,docCode){ //查詢科別醫院簡介
                this.countDown();//開始計時
                this.funListLoading = true;
                this.tableAlert = false;
                this.doctorList = [];
                let url = '';
                // let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let docCODE = docCode==""?'ALL':docCode;
                url = this.$store.state.AppSetting.backSrvUrl + "hospdoc/datasearch/primarykeys/"+zone+"/"+docType+"/"+docCODE;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.doctorList = response.data.resultSet;
                    }else{
                        this.tableAlert = true;
                        this.doctorList = [];
                    }
                    this.funListLoading = false;
                    this.stopCountDown();
                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.doctorList = [];
                    } catch(err) {
                        this.doctorList = [];
                    }
                    this.funListLoading = false;
                    this.stopCountDown();
                });
            },

            axios_postHospDoc(postData){ //新增 醫師簡介
                let postList = [];
                postList.push(postData);
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "hospdoc/"+zone;

                this.$http.post(url,postList).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')){
                        this.editDialog = false;
                        this.axios_getHospDocListData(this.zoneType,postData.docType,'ALL');


                        // this.search = response.data.resultSet[0].dataType
                    }
                    this.snText = response.data.message;
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_putHospDoc(putData){ //修改 醫師簡介
                let postList = [];
                postList.push(putData);
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "hospdoc/"+zone;

                this.$http.put(url,postList).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0){
                        this.editDialog = false;
                        this.axios_getHospDocListData(this.zoneType,putData.docType,'ALL');


                    }
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_deleteDoctor(item){   //刪除單筆資料
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "hospdoc/s/"+item.zone+"/"+item.docType+"/"+item.docCode;

                this.$http.delete(url).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0){
                        this.axios_getHospDocListData(this.zoneType,this.docType,"ALL");
                        this.deleteDialog = false;
                    }

                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_getZoneNameALL (){  //查詢院區名稱
                this.zoneNameList =[];
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "zoneset/datasearch/primarykeys/ALL";
                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.zoneNameList = response.data.resultSet;
                    }else{
                        this.zoneNameList =[];
                    }
                }).catch(error =>  {
                    this.zoneNameList =[];
                    try {
                        console.log(error.response.data.status);

                    } catch(err) {
                        console.log(err.toString())
                    }
                });
            },
        }
    }
</script>

<style scoped>

    .cardBgColorStyle{
        padding:0px 10px;
        background-color: rgba(255,255,255,1);
    }

    .labelFont{
        line-height: 62px;
    }


</style>